import { IGlobalAlert } from 'src/@types/global-alert';
import { create } from 'zustand';

interface GlobalAlertState {
  alert: IGlobalAlert | null;
  setAlert: (_alert: IGlobalAlert | null) => void;
  hasAlert: boolean;
  setHasAlert: (hasAlert: boolean) => void;
}

export const globalAlertState = create<GlobalAlertState>((set) => ({
  alert: null,
  setAlert: (alert) => set({ alert }),
  hasAlert: false,
  setHasAlert: (hasAlert) => set({ hasAlert }),
}));

export const useGlobalAlert = globalAlertState;
